import React from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import { Flex, FlexColumn } from 'src/components/flex';
import Responsive from 'src/components/responsive';
import ButtonLink from 'src/components/button-link';
import { useUnmatchedListings } from 'src/services/api/listings';
import pluralize from 'pluralize';

export default function UnmatchedListingAlert() {
    const { data } = useUnmatchedListings();
    const unmatchedListings = data?.unmatched ?? [];
    const unreadCount = unmatchedListings.filter((l) => l.notification_id != null).length;
    if (unreadCount === 0) {
        return null;
    }

    return (
        <Responsive desktop>
            <Alert
                severity="error"
                color="error"
                sx={{
                    '& .MuiAlert-message': { width: '100%' },
                    '& .MuiAlert-icon': { paddingTop: '10px' },
                }}
            >
                <Flex width="100%" justifyContent="space-between" alignItems="center">
                    <FlexColumn>
                        <Typography fontWeight="bold" color="error">
                            Unmatched Listings
                        </Typography>
                        <Typography variant="body2" color="error">
                            {`${unreadCount} ${pluralize('listings', unreadCount)} ${unreadCount === 1 ? 'is' : 'are'} not matched to a property.`}
                        </Typography>
                    </FlexColumn>

                    <ButtonLink variant="outlined" color="error" href="/landlord/inner/properties/listings">
                        {`View ${pluralize('listing', unreadCount)}`}
                    </ButtonLink>
                </Flex>
            </Alert>
        </Responsive>
    );
}
